import React from "react";
import { SvgIcon } from "../../Components/SvgIcon/SvgIcon";
import classNames from "classnames";

interface ImageGalleryArrowProps {
  prev?: boolean;
  onClick?: () => void;
}

export const ImageGalleryArrow: React.FC<ImageGalleryArrowProps> = ({
  prev,
  onClick,
}) => {
  const icon = prev ? "chevron-left" : "chevron-right";
  const buttonClass = prev
    ? "prev"
    : "next";

  return (
    <button
      onClick={onClick}
      className={classNames("slick-slider-btn", buttonClass)}
    >
      <SvgIcon iconName={icon} />
    </button>
  );
};
